import { CategoryGroupPreviewPage } from "@/features/category-group/pages/CategoryGroupPreviewPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-group/$id/preview")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <CategoryGroupPreviewPage id={id} />;
}
